<template>
    <div>
        <div class="card-body border-top" v-if="processCard">
            <div class="form-group">
                <label class="d-block">{{ $t("details.form.card.number") }}</label>
                <input type="text" v-model="cardNumber" class="form-control" @keyup="resetCard" />
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label class="d-block">{{ $t("details.form.card.expiry_date") }}</label>
                        <div class="row">
                            <div class="col-6">
                                <select v-model="expiryMonth" class="custom-select" @change="resetCard">
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </select>
                            </div>
                            <div class="col-6">
                                <select v-model="expiryYear" class="custom-select" @change="resetCard">
                                    <option :value="year" v-for="year in this.years()">{{ year }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label class="d-block">CVV / CVC / CVE</label>
                        <input type="text" v-model="cvv" class="form-control" @keyup="resetCard" />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body border-top">
            <div class="row">
                <div :class="selectedMethod.fields.fields.length % 2 === 0 || idx < selectedMethod.fields.fields.length -1 ? 'col-12 col-md-6' : 'col-12'" v-for="(field, idx) in selectedMethod.fields.fields">
                    <div class="form-group">
                        <label class="d-block">{{ field.label }}</label>
                        <component :is="field.component" :field="field" v-model="formData[field.name]" @input="handleOnChange" />
                    </div>
                </div>
            </div>
            <div class="row" v-if="customer.country == 'BR'">
                <div class="col-12">
                    <p class="small">
                        Esta é uma compra internacional, sujeita a uma operação de câmbio, que será processada pelo EBANX de acordo com seus <a href="https://www.ebanx.com/br/termos/" target="_blank">termos e condições</a>.
                        Ao clicar em comprar, você dá ciência e aceita os termos desta transação.
                    </p>
                </div>
            </div>
            <div class="row" v-if="customer.country == 'AR'">
                <div class="col-12">
                    <p class="small">
                        Our payment partner may be required to add taxes (such as IIBB and Solidarity Tax) to the purchase price in compliance with local tax regulations.
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapState } from "vuex";

    import InputText from "./Dynamic/InputText";
    import InputEmailAddress from "./Dynamic/InputEmailAddress";
    import InputSelect from "./Dynamic/InputSelect";
    import InputTel from "./Dynamic/InputTel";

    export default {
        name: "FieldsEbanx",
        data() {
            return {
                cardNumber : '',
                expiryMonth : '',
                expiryYear : '',
                cvv: '',
                tokenizedCard : false,
                authenticationData : false,
                formData : {},
            }
        },
        methods: {
            cardIsValid: function(cardNo) {

                var bin = cardNo.substr(0, 6);

                if (!window.tebex.methods.ebanx.binList[bin]) {
                    console.log("Not a valid bin");
                    return false;
                }

                // Accept only digits, dashes or spaces
                if (/[^0-9-\s]+/.test(cardNo)) return false;

                // The Luhn Algorithm. It's so pretty.
                let nCheck = 0, bEven = false;
                cardNo = cardNo.replace(/\D/g, "");

                for (var n = cardNo.length - 1; n >= 0; n--) {
                    var cDigit = cardNo.charAt(n),
                        nDigit = parseInt(cDigit, 10);

                    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

                    nCheck += nDigit;
                    bEven = !bEven;
                }

                return (nCheck % 10) == 0;
            },
            resetCard: function() {
                this.tokenizedCard = false;
                this.authenticationData = false;
                this.handleOnChange();
            },
            generate3DS: function() {
                    const orderInformation = {
                        amountDetails: {
                            totalAmount: this.basket.price.total + "",
                            currency: "BRL"
                        },
                        billTo: {
                            address1: this.formData.address,
                            administrativeArea: this.formData.state,
                            country: "BR",
                            locality: this.formData.city,
                            email: this.customer.email,
                            homePhone: this.formData['phone_number'],
                            postalCode: this.formData.zipcode,
                            mobilePhone: this.formData['phone_number']
                        }
                    };

                    const paymentInformation = {
                        card: {
                            number: this.cardNumber,
                            expirationMonth: this.expiryMonth,
                            expirationYear: this.expiryYear,
                            holderName: this.customer.first_name + " " + this.customer.last_name
                        }
                    };

                    const personalIdentification = {
                        id: this.formData.document,
                        type: "CPF"
                    };

                    const options = {
                        orderInformation,
                        paymentInformation,
                        personalIdentification
                    };

                    return EBANX.threeDSecure.authenticate(options);
            },
            handleOnChange: function(ev) {
                if (!this.processCard) {
                    this.buildPaymentMethodData();
                }

                if (this.tokenizedCard) {
                    this.buildPaymentMethodData();
                } else {
                    if (this.cardNumber.length > 12
                        && this.cardIsValid(this.cardNumber)
                        && (parseInt(this.expiryMonth) > ((new Date()).getMonth()) || parseInt(this.expiryYear) > ((new Date()).getFullYear()))
                        && this.cvv.length >= 3
                    ) {
                        const tokenizeOptions = {
                            card: {
                                number: this.cardNumber,
                                dueDate: this.expiryMonth + "/" + this.expiryYear,
                                holderName: this.customer.first_name + " " + this.customer.last_name,
                                cvv: this.cvv
                            },
                            countryCode: this.customer.country.toLowerCase(),
                        };

                        EBANX.cardTokenizer.tokenize(tokenizeOptions).then((tokenizedCard) => {
                            this.tokenizedCard = tokenizedCard;
                            this.buildPaymentMethodData()
                        });
                    }
                }

            },
            buildPaymentMethodData: function() {
                let valid = true;
                let data = {};

                if (this.processCard) {
                    data['ebanx_token'] = this.tokenizedCard;
                    data['card_bin'] = this.cardNumber.substr(0, 6);
                }

                for (let i in this.selectedMethod.fields.fields) {
                    let field = this.selectedMethod.fields.fields[i];

                    let value = this.formData[field.name];

                    if (!value) {
                        valid = false;
                    }

                    data[field.name] = value;
                }

                if (valid) {
                    if (this.processCard && this.customer.country === 'BR') {
                        if (this.authenticationData === true) {
                            //This is already in progress
                            valid = false;
                        } else if (this.authenticationData === false) {
                            valid = false;
                            this.authenticationData = true;
                            this.generate3DS().then((authenticationData) => {
                                // use the authenticationData object to fullfil your payment
                                this.authenticationData = authenticationData;
                                this.buildPaymentMethodData()
                            })
                            .catch((error) => {
                                this.authenticationData = false;
                            });
                        }
                    }
                }

                data.authenticationData = this.authenticationData;

                this.$store.commit('setPaymentMethodData', {
                    valid : valid,
                    data: data
                });
            },
            years () {
                const year = new Date().getFullYear()
                return Array.from({length: 10}, (value, index) => year + index)
            }
        },
        computed: {
            ...mapState({
                selectedMethod: state => state.payment.selectedMethod,
                customer: state => state.customer,
                payment: state => state.payment,
                basket: state => state.basket
            }),
            processCard() {
                return this.selectedMethod.ident === 'domesticcards';
            }
        },
        mounted() {
            EBANX.init({
                publicIntegrationKey: window.tebex.methods.ebanx.publicKey,
                country: this.customer.country.toLowerCase(),
                mode: window.tebex.methods.ebanx.environment,
            });

            if (this.processCard) {
                EBANX.threeDSecure.authenticate
            }

            this.$store.commit('setPaymentMethodData', {
                valid : false,
                data: {}
            });

            this.buildPaymentMethodData()
        },
        components: {
            InputText,
            InputEmailAddress,
            InputSelect,
            InputTel
        },
    }
</script>

<style scoped>

</style>
